export default ['bg', 'ru', 'world'];
